import barba from '@barba/core';
import * as rive from "@rive-app/canvas";



let r;

function rive_animation()
{
    if (!customElements.get('rive-animation'))
    {
        customElements.define(
            'rive-animation',
            class RiveAnimation extends HTMLElement {
                constructor()
                {
                    super();
                    this.elements = {
                        canvas: this.querySelector('canvas')
                    }

                    const pathToRiveFile = this.elements.canvas.dataset.riveFile;

                    r = new rive.Rive({
                        src: pathToRiveFile,
                        canvas: this.elements.canvas,
                        autoplay: true,
                        stateMachines: "Primary State",
                        onLoad: () => {
                            r.resizeDrawingSurfaceToCanvas();
                        },
                    });

                    window.addEventListener("resize", () => {
                        r.resizeDrawingSurfaceToCanvas();
                    });

                    console.log('create rive element');
                }
            }
        );
    }
}

barba.hooks.enter((data) => {

    rive_animation();

});

barba.hooks.afterLeave((data) => {
    
    r.cleanup();

});

rive_animation();